// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Payer } from "./Payer.ts";

export const recurringWorkRequirementEntryPointTypeEnum = {
  RECURRING_WORK_REQUIREMENT: "RECURRING_WORK_REQUIREMENT",
} as const;

export type RecurringWorkRequirementEntryPointTypeEnumKey =
  (typeof recurringWorkRequirementEntryPointTypeEnum)[keyof typeof recurringWorkRequirementEntryPointTypeEnum];

export const recurringWorkRequirementTypeEnum = {
  VANCE_RECURRING_WORK_REQUIREMENT: "VANCE_RECURRING_WORK_REQUIREMENT",
} as const;

export type RecurringWorkRequirementTypeEnumKey =
  (typeof recurringWorkRequirementTypeEnum)[keyof typeof recurringWorkRequirementTypeEnum];

export type RecurringWorkRequirement = {
  /**
   * @description Active Medicaid coverage details. Absent when no active coverage is found.
   */
  activeMedicaid?: Payer;
  /**
   * @description Active Medicare coverage details. Absent when no active coverage is found.
   */
  activeMedicare?: Payer;
  /**
   * @type string
   */
  entryPointType: RecurringWorkRequirementEntryPointTypeEnumKey;
  /**
   * @type string
   */
  memberId: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: RecurringWorkRequirementTypeEnumKey;
  /**
   * @description The date work requirements are due.
   * @type string, date
   */
  workRequirementDate: string;
  /**
   * @type string
   */
  workspaceId: string;
};
